export class RegistrationConstants {
  static SIGNUP_ACCOUNT = 'signup-account';
  static SIGNUP_EMAIL = 'signup-email-options';
  static SIGNUP_TEXT = 'signup-text-options';
  static SIGNUP = 'signup';
}
